import { Box, IconButton, Link, Tag } from '@dev-spendesk/grapes';
import { useState } from 'react';

import { useUserRoles } from 'src/core/modules/app/hooks/useUserRoles';

import { LocalStorageKey } from '../../../constants/storage';
import { useCompany } from '../../../modules/app/hooks/useCompany';
import { useTranslation } from '../../hooks/useTranslation';

export function InternationalPriceDropPopup() {
  const { t } = useTranslation('global');

  const company = useCompany();

  const { isRequester } = useUserRoles();

  const hasPopupClosed = localStorage.getItem(
    LocalStorageKey.InternationalTransfersPriceDropPopupClosed,
  );

  const [isOpen, setIsOpen] = useState<boolean>(hasPopupClosed === null);

  const closePopup = () => {
    localStorage.setItem(
      LocalStorageKey.InternationalTransfersPriceDropPopupClosed,
      new Date().toISOString(),
    );

    setIsOpen(false);
  };

  // Hide for non admins or controllers.
  if (isRequester) {
    return null;
  }

  // Hide for non-EEA companies.
  if (company.currency !== 'EUR') {
    return null;
  }

  // Show only once using local storage cache.
  if (!isOpen) {
    return null;
  }

  return (
    <Box
      data-testid="international-price-drop-popup"
      className="elevation-m bg-background-primary-default absolute right-0 bottom-0 z-50 m-16 max-w-1/3 space-y-12"
    >
      <IconButton
        onClick={closePopup}
        aria-label="Close popup"
        className="absolute top-0 right-0 m-16"
        variant="tertiaryBrand"
        iconName="cross"
      />

      <Tag iconName="megaphone" variant="ocean">
        New
      </Tag>

      <p className="title-l">
        {t('common.internationalTransferPriceDrop.title')}
      </p>

      <p className="body-l text-content-secondary-bg-primary">
        {t('common.internationalTransferPriceDrop.subtitle')}
      </p>

      <Link
        variant="primary"
        href="https://helpcenter.spendesk.com/en/articles/11798230-pay-international-invoices-directly-from-spendesk#h_84e64de992"
        isExternal
      >
        {t('common.internationalTransferPriceDrop.link')}
      </Link>
    </Box>
  );
}
